import axios from 'axios'

export const getPeriods = () => {
  return axios.get('/leaderboard/periods')
}

export const getLeaderboardDataForPeriod = (period) => {
  return axios.get(`/leaderboard/ranking?period=${period}`)
}

export const getMyRankings = () => {
  return axios.get(`/leaderboard/my-ranking`)
}

export const getMyRankingsDebug = (debugUserID) => {
  return axios.get(`/leaderboard/debug/my-ranking`, { params: { debugUserId: debugUserID } })
}

export const downloadLeaderboardList = ({ period, leaderboardType }) => {
  return axios.get(`/leaderboard/ranking-download?period=${period}&type=${leaderboardType}`, { responseType: 'blob' })
}
